export default __webpack_public_path__ + "static/media/review-2.edb77e4c.jpg";